import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const ContentUser = ({ text, color }) => (
  <div className="content-user">
    <div
      className="content-text-user"
      style={{
        background: color.button,
      }}
    >
      {text}
    </div>
  </div>
);

ContentUser.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.object.isRequired,
};

export default ContentUser;
